module.exports = __webpack_public_path__ + "img/0Q3A5468_L.72d52e2b.webp";